export default __webpack_public_path__ + "static/media/moscow-method.962d0ed2.svg";